<template>
  <li class="otj-dropdown" :class="{ 'is-open': isOpen }" ref="otjDropdown" @focusout="handleClickOutside">
    <button
      type="button"
      class="btn-icon otj-dropdown-btn"
      :aria-expanded="isOpen.toString()"
      aria-controls="otj-dropdown-menu"
      aria-haspopup="menu"
      @click="toggleOpen"
      @keydown.enter.prevent="toggleOpen"
      @keydown.space.prevent="toggleOpen"
      @keydown.down.prevent="openAndFocusMenu"
      @keydown.esc.prevent="closeDropdown"
    >
      <i class="fas fa-clock" aria-hidden="true"></i>
      <span>O.T.J</span>
      <i class="fas fa-caret-down" aria-hidden="true"></i>
    </button>
    <ul id="otj-dropdown-menu" class="dropdown k-menu-panel" :class="{ 'is-open': isOpen }" :hidden="!isOpen" role="menu">
      <li class="otj-dropdown-item k-menu-item" role="none">
        <button type="button" role="menuitem" @click="openQuickAdd">
          <i class="fas fa-plus" aria-hidden="true"></i>
          <span>Quick Add</span>
        </button>
      </li>
      <li class="otj-dropdown-item k-menu-item" role="none">
        <router-link role="menuitem" :to="{ name: 'programme_otj_page', params: { programmeId: programmeId } }">
          <i class="fas fa-clock" aria-hidden="true"></i>
          <span>O.T.J. Logs</span>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<style scoped>
.otj-dropdown-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.otj-dropdown.is-open > .otj-dropdown-btn {
  color: var(--kate-neon-primary-text);
  background-color: var(--kate-panel-alt);
}

.otj-dropdown-btn:focus-visible,
.otj-dropdown :deep(.k-menu-item > a:focus-visible),
.otj-dropdown :deep(.k-menu-item > button:focus-visible) {
  outline: var(--kate-focus-ring-width) solid var(--kate-focus-ring-color);
  outline-offset: var(--kate-focus-ring-offset);
}

.otj-dropdown :deep(.k-menu-item > a:focus-visible),
.otj-dropdown :deep(.k-menu-item > button:focus-visible) {
  outline-offset: -2px;
}
</style>

<script>
import useOtjModalStore from '@stores/otj-modal-store';

export default {
  props: {
    programmeId: {
      type: Number,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      otjModalStore: useOtjModalStore(),
    };
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  watch: {
    route() {
      this.closeDropdown();
    },
  },

  computed: {
    route() {
      return this.$route;
    },
  },

  methods: {
    toggleOpen() {
      if (this.isOpen) {
        this.closeDropdown();
      } else {
        this.$emit('open');
      }
    },

    closeDropdown() {
      this.$emit('close');
    },

    openAndFocusMenu() {
      if (!this.isOpen) {
        this.$emit('open');
      }
      this.$nextTick(() => {
        const firstMenuItem = this.$refs.otjDropdown?.querySelector('#otj-dropdown-menu a, #otj-dropdown-menu button');
        firstMenuItem?.focus();
      });
    },

    handleClickOutside(event) {
      const otjDropdown = this.$refs.otjDropdown;
      if (!otjDropdown) {
        return;
      }

      if (event.type === 'focusout') {
        const relatedTarget = event.relatedTarget;
        if (relatedTarget && !otjDropdown.contains(relatedTarget)) {
          this.closeDropdown();
        }
        return;
      }

      if (!otjDropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },

    openQuickAdd() {
      this.otjModalStore.openOtjModal(this.programmeId);
    },
  },
};
</script>
